﻿<template>
    <div v-if="!isToday() && display_day()" class="tc-day" :class="{ 'is-full': isFull(), 'is-low': Is_Low() }">
        <div v-if="hasAddOn()" class="addon-ribbon" aria-hidden="true"></div>

        <button type="button" class="tc-day-btn departures" :class="{ selected: isDate_Selected() }"
            :disabled="isFull()" :aria-pressed="isDate_Selected()" :aria-label="Day_Label()" :title="Day_Title()"
            @click="date_clicked()">
            <span class="day-label">{{getDay()}}</span>
            <span class="tc-day-price price" v-if="getPrice() != ''">{{getPrice()}}</span>
            <small class="tc-day-seats capacity" v-if="getSeats() != ''">{{getSeats()}}</small>
        </button>
    </div>
</template>

<script lang="ts" src="./calendar_day.ts"></script>